// src/layouts/HRLayout.js
import React from "react";
import HRSidebar from "../components/HRSidebar";
import { Outlet } from "react-router-dom";
import SchoolHeader from "../components/SchoolHeader";
import Navbar from "../components/Navbar";

export default function HRLayout({ user, setUser }) {
  return (
    <div className="hr-layout" style={{ minHeight: "100vh", display: "flex" }}>
      <HRSidebar />
      <div style={{ flexGrow: 1, minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <SchoolHeader />
        {/* Header */}
        <header className="hr-header" style={{ padding: "18px 24px", background: "var(--theme-bg)", borderBottom: "1px solid var(--theme-border)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <i className="bi bi-people" style={{ fontSize: 24, color: "var(--theme-primary)" }}></i>
            <h5 style={{ margin: 0 }}>HR / Payroll System</h5>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{ color: "#6c757d" }}>
              {user ? user.username : "Guest"}
            </span>
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => {
                localStorage.removeItem("user");
                window.location.href = "/login";
              }}
            >
              Logout
            </button>
          </div>
        </header>
        <Navbar />
        {/* Main content area */}
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
